import todoapp from "../imges/todoapp.png";
import pokemonsss from "../imges/pokemonsss.png";
import gallery from "../imges/gallery.png";
import food from "../imges/food.png";
import EMLMovies from "../imges/EMLMovies.png";
import lesson from "../imges/lesson.png";
import blog from "../imges/blog.png";
const projectData = [
  {
    id: 6,
    title: "Blog",
    Url: "",
    githuburl: "https://github.com/KJ-MU/bllog-project",
    imageUrl: blog,
    info: "Rreact-JS NodeJs MangoDB",
  },
  {
    id: 5,
    title: "Nerdify",
    Url: "/projects/nerdify",
    githuburl: "https://github.com/KJ-MU/Nerdify",
    imageUrl: lesson,
    info: "Rreact-JS NodeJs MangoDB",
  },
  {
    id: 0,
    title: "EML Movies",
    Url: "https://eml-movies.netlify.app/",
    githuburl: "https://github.com/KJ-MU/movie-api",
    imageUrl: EMLMovies,
    info: "Rreact-JS Redux",
  },
  {
    id: 1,
    title: "Todo App",
    Url: "https://todolistkj.netlify.app/",
    githuburl: "https://github.com/KJ-MU/react-todo-starting-point",
    imageUrl: todoapp,
    info: "Rreact-JS Tailwind",
  },
  {
    id: 2,
    title: "Pokemons",
    Url: "https://tranquil-griffin-2c60fe.netlify.app/",
    githuburl: "https://github.com/KJ-MU/JS-Pokemon_API_Project",
    imageUrl: pokemonsss,
    info: "HTML CSS JS",
  },
  {
    id: 3,
    title: "Art Galley",
    Url: "https://kj-gallery.netlify.app/",
    githuburl: "https://github.com/KJ-MU/KJ-GALLERY",
    imageUrl: gallery,
    info: "HTML CSS",
  },
  {
    id: 4,
    title: "Fast Food",
    Url: "https://magnificent-moonbeam-8c9595.netlify.app/",
    githuburl: "https://github.com/KJ-MU/GitGitHub-Recipe-Book-Task",
    imageUrl: food,
    info: "HTML CSS",
  },
];
export default projectData;
